import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import Icon from "../../shared_modules/common/icons/Icon";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

class Password extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgData: {
        errors: { password: {} },
        info: { password: {} },
      },
    };
  }

  static defaultProps = {
    element: {
      name: "password",
      prefix: "pf-contact-",
      id: "pf-contact-password",
      label: "Create Password",
      placeHolder: "************",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
    },
    pwMaxLength: 30,
    pwMinLength: 8,
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 6 },
    },
  };

  initMsgObj = () => {
    const { element } = this.props,
      msgData = {
        errors: {},
        info: {},
      };

    msgData.errors[element.name] = {};
    msgData.info[element.name] = {};

    return msgData;
  };

  generateMessage = (msgType) => {
    const { element } = this.props,
      notation = msgType === "error" ? "errors" : "info",
      msgData = this.initMsgObj();

    let msg = "";

    if (msgType === "info") {
      msg = "Enter your password.";
    } else if (msgType === "error") {
      msg = `Password must be 8 to 30 characters with at least one letter and one number,
              and no special characters except !, @, #, $ or % `;
    }

    msgData[notation][element.name] = {
      type: msgType,
      msg: msg,
      id: element.id,
      slug: element.name,
    };

    return msgData;
  };

  isValid = (value) => {
    const { pwMaxLength, pwMinLength } = this.props,
      pwRegexStart = "^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%]",
      pwRegexEnd = `{${pwMinLength},${pwMaxLength}}`,
      pwRegexStr = `${pwRegexStart}${pwRegexEnd}$`,
      proper = new RegExp(pwRegexStr, "g");

    return proper.test(value);
  };

  handleChange = (ev) => {
    const { fieldMetadata } = this.props;
    fieldMetadata.value = ev.target.value;
  };

  handleBlur = (ev) => {
    const { onEventCallback, fieldMetadata } = this.props;
    let msgData = this.initMsgObj();

    if (!this.isValid(fieldMetadata.value)) {
      msgData = this.generateMessage("error");
      fieldMetadata.status = "invalid";
      fieldMetadata.isValid = false;
    } else {
      fieldMetadata.status = "";
      fieldMetadata.isValid = true;
    }

    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, fieldMetadata);
    }

    this.setState({
      msgData,
    });
  };

  handleFocus = (ev) => {
    const { fieldMetadata } = this.props;

    fieldMetadata.status = "";
    this.setState({
      msgData: this.generateMessage("info"),
    });
  };

  render() {
    const { colLayout, element, fieldMetadata } = this.props;
    let iconProps = {},
      { msgData } = this.state;

    if (fieldMetadata.status === "invalid") {
      msgData = this.generateMessage("error");
    }

    if (fieldMetadata.isValid === true) {
      iconProps.type = "success";
    }

    return (
      <Row className={element.id}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label htmlFor={element.id}>{element.label}</label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <input
            key={fieldMetadata.value}
            id={element.id}
            name={element.name}
            className={fieldMetadata.status}
            type={element.name}
            placeholder={element.placeHolder}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            defaultValue={fieldMetadata.value}
            autoComplete={fieldMetadata.autocomplete || null}
          />
          <Icon {...iconProps} />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[3]}>
          <ValidationMsg
            who={element.name}
            filterFields={[element.name]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

Password.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  fieldMetadata: PropTypes.object.isRequired,
  pwMinLength: PropTypes.number.isRequired,
  pwMaxLength: PropTypes.number.isRequired,
};

export default Password;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');